var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component-copy-6",
    transform: "translate(-27.000000, -350.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5948777,6.84092308 C8.18693525,6.84092308 7.81444604,6.56723077 7.70486331,6.15369231 L6.59061871,1.93015385 C6.46077698,1.43723077 6.75361151,0.931846154 7.24535252,0.801692308 C7.73801439,0.670615385 8.24080576,0.965076923 8.37110791,1.458 L9.48535252,5.68153846 C9.61519424,6.17446154 9.32235971,6.67984615 8.83061871,6.81 C8.75188489,6.83076923 8.67269065,6.84092308 8.5948777,6.84092308 L8.5948777,6.84092308 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90319424,9.54 C5.82538129,9.54 5.74618705,9.53030769 5.66699281,9.50907692 L1.45404317,8.39169231 C0.96276259,8.26107692 0.669467626,7.75615385 0.799309353,7.26323077 C0.929151079,6.77076923 1.43102158,6.47492308 1.92506475,6.60692308 L6.13801439,7.72430769 C6.62929496,7.85492308 6.92258993,8.35984615 6.7927482,8.85276923 C6.68408633,9.26676923 6.31113669,9.54 5.90319424,9.54 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2531223,17.424 C22.1753094,17.424 22.0961151,17.4143077 22.0169209,17.3930769 L17.8039712,16.2756923 C17.3126906,16.1450769 17.0193957,15.6401538 17.1492374,15.1472308 C17.2790791,14.6547692 17.7804892,14.3589231 18.2749928,14.4909231 L22.4879424,15.6083077 C22.979223,15.7389231 23.272518,16.2438462 23.1426763,16.7367692 C23.033554,17.1507692 22.6610647,17.424 22.2531223,17.424 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4599712,23.2296923 C16.0520288,23.2296923 15.6795396,22.956 15.5699568,22.5424615 L14.4557122,18.3193846 C14.3258705,17.8264615 14.618705,17.3210769 15.110446,17.1909231 C15.6035683,17.0593846 16.1058993,17.3543077 16.2362014,17.8472308 L17.350446,22.0703077 C17.4802878,22.5632308 17.1874532,23.0686154 16.6957122,23.1987692 C16.6169784,23.2195385 16.5377842,23.2296923 16.4599712,23.2296923 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1800863,13.5756923 C16.9443453,13.5756923 16.7090647,13.4856923 16.529036,13.3052308 C16.1694388,12.9447692 16.1694388,12.3604615 16.529036,11.9995385 L22.3709928,6.14446154 C22.7305899,5.78446154 23.3134964,5.784 23.6730935,6.14446154 C24.0326906,6.50492308 24.0326906,7.08923077 23.6730935,7.45015385 L17.8311367,13.3056923 C17.6511079,13.4856923 17.4153669,13.5756923 17.1800863,13.5756923 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0215827,7.72107692 C22.7858417,7.72107692 22.5505612,7.63107692 22.3705324,7.45061538 L16.5096978,1.57569231 C16.1501007,1.21523077 16.1501007,0.630923077 16.5096978,0.270461538 C16.869295,-0.09 17.4522014,-0.09 17.8117986,0.270461538 L23.6726331,6.14538462 C24.0322302,6.50584615 24.0322302,7.09015385 23.6726331,7.45061538 C23.4926043,7.63061538 23.2573237,7.72107692 23.0215827,7.72107692 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3201727,7.70169231 C11.0844317,7.70169231 10.8491511,7.61169231 10.6691223,7.43123077 C10.3095252,7.07076923 10.3095252,6.48646154 10.6691223,6.126 L16.5096978,0.270461538 C16.869295,-0.09 17.4522014,-0.09 17.8117986,0.270461538 C18.1713957,0.630923077 18.1713957,1.21523077 17.8117986,1.57569231 L11.971223,7.43123077 C11.7911942,7.61123077 11.5559137,7.70169231 11.3201727,7.70169231 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78077698,24 C6.54503597,24 6.3097554,23.91 6.12972662,23.7295385 C5.7701295,23.3690769 5.7701295,22.7847692 6.12972662,22.4243077 L11.971223,16.5687692 C12.3308201,16.2083077 12.9137266,16.2083077 13.2733237,16.5687692 C13.6329209,16.9292308 13.6329209,17.5135385 13.2733237,17.874 L7.43182734,23.7295385 C7.25179856,23.91 7.01605755,24 6.78077698,24 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78077698,24 C6.54503597,24 6.3097554,23.91 6.12972662,23.7295385 L0.26981295,17.8555385 C-0.0897841727,17.4950769 -0.0897841727,16.9107692 0.26981295,16.5503077 C0.629410072,16.1898462 1.21231655,16.1898462 1.57191367,16.5503077 L7.43182734,22.4247692 C7.79142446,22.7852308 7.79142446,23.3695385 7.43182734,23.73 C7.25179856,23.91 7.01605755,24 6.78077698,24 L6.78077698,24 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.920863309,18.1255385 C0.685122302,18.1255385 0.449841727,18.0355385 0.26981295,17.8550769 C-0.0897841727,17.4946154 -0.0897841727,16.9103077 0.26981295,16.5498462 L6.11084892,10.6943077 C6.47044604,10.3338462 7.05335252,10.3338462 7.41294964,10.6943077 C7.77254676,11.0547692 7.77254676,11.6390769 7.41294964,11.9995385 L1.57191367,17.8555385 C1.39188489,18.0355385 1.15660432,18.1255385 0.920863309,18.1255385 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/componentsIcon.321be22f2b949148771faf4035700340.svg";